import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// @atlaskit
import Lozenge from '@atlaskit/lozenge';
import Modal from '@atlaskit/modal-dialog';
import Spinner from '@atlaskit/spinner';

// @source
import { crypto } from '../../../../utils';
import { Messages } from '../../../components';
import { Report as API } from '../../../../server';
import ErrorModal from './ErrorModal';

const initialState = {
  isLoading: false,
  message: false,
};

class DeleteReport extends Component {
  constructor(props) {
    super(props);
    this.state = initialState;
    this.unmount = false;
    this.uuid = crypto.decode(this.props.uuid);
    this.onSubmitHandle = this.onSubmitHandle.bind(this);
  }

  componentWillUnmount() {
    this.unmount = true;
  }

  onSubmitHandle(event) {
    event.preventDefault();

    this.setState({
      isLoading: true,
      message: false,
    });

    API.remove({
      data: {
        report: this.report.Name,
      },
      dispatch: this.props.dispatch,
      success: () => {
        this.props.onClose();
      },
      error: (messages) => {
        this.setStateUnmount({
          isLoading: false,
          message: (
            <Messages
              component="Modal"
              items={messages}
              onClose={() => this.setState({ message: false })}
            />
          ),
        });
      },
    });
  }

  setStateUnmount(state) {
    if (this.unmount) return;
    this.setState(state);
  }

  render() {
    this.report = this.props.reports.data.find(item => item.Name === this.uuid);

    if (this.props.reports.override && !this.report) {
      return <ErrorModal onClose={this.props.onClose} />;
    }

    return (
      <Modal
        appearance="warning"
        heading="Delete report"
        onClose={this.props.onClose}
        width="small"
        actions={[{
          appearance: 'primary',
          isDisabled: !this.props.reports.override,
          isLoading: this.state.isLoading,
          onClick: this.onSubmitHandle,
          text: 'Delete report',
          type: 'submit',
        }, {
          appearance: 'subtle',
          onClick: this.props.onClose,
          text: 'Cancel',
        }]}
      >
        {this.props.reports.override
          ? (
            <div style={{ paddingLeft: 34 }}>
              <p>Do you want to permanently delete this report?</p>
              <p>
                This is:
                <Lozenge>{this.report.Name}</Lozenge>
              </p>
            </div>
          )
          : (
            <div style={{ padding: '14px 0', textAlign: 'center' }}>
              <Spinner size="medium" />
            </div>
          )}
        {this.state.message}
      </Modal>
    );
  }
}

DeleteReport.propTypes = {
  dispatch: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  reports: PropTypes.shape().isRequired,
  uuid: PropTypes.string.isRequired,
};

const mapStateToProps = state => ({
  reports: state.Report,
});

export default connect(mapStateToProps)(DeleteReport);
